export default {"src":"/_next/static/media/logo.c460823c.svg","height":52,"width":328};